module.exports = __webpack_public_path__ + "static/media/check-fill.b11c6e54.svg";